namespace SP.Data {
    export class DeliveryMethod {

        static async getDroppoints(deliveryMethodId: string, customerId: string, country: string, zipcode: string, city: string, street: string) {

            var url = `/api/v1/droppoint/list/${deliveryMethodId}?country=${country}&zipcode=${zipcode}&city=${city}&street=${street}&maxresults=${100}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'api-customer': `${customerId}`
                }
            });

            const result = await response.json();
            console.log(result);
            if (result.status != 200)
                await SP.alertX(result.msg);

            return result.data as DropPointInfo[];
        }

    }
}